import { AppControllerClient } from "@amazon-connect/app-controller";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/**
 * AppControllerClient: enumerate and control other workspace apps. Request-only.
 * `getAppConfig`/`launchApp` take an ARN-or-name; `getApp`/`focusApp`/`closeApp` take the
 * running app's instanceId — the two are not interchangeable (see `sdk-signatures.md`).
 */
export const appControllerModule: ClientModule = {
  id: "app-controller",
  label: "App Controller",
  pkg: "@amazon-connect/app-controller",
  clientExport: "AppControllerClient",
  kind: "request-only",
  create: (provider: AmazonConnectProvider) =>
    new AppControllerClient({ provider }) as unknown as Record<string, unknown>,
  events: [],
  requests: [
    { name: "getAppCatalog", args: [] },
    { name: "getApps", args: [] },
    {
      name: "getApp",
      args: [{ k: "instanceId", type: "string", required: true }],
    },
    {
      name: "getAppConfig",
      args: [{ k: "arnOrName", type: "string", required: true }],
    },
    {
      name: "launchApp",
      args: [
        { k: "arnOrName", type: "string", required: true },
        { k: "options", type: "json" },
      ],
      mutating: true,
    },
    {
      name: "focusApp",
      args: [{ k: "instanceId", type: "string", required: true }],
      mutating: true,
    },
    {
      name: "closeApp",
      args: [{ k: "instanceId", type: "string", required: true }],
      mutating: true,
    },
  ],
};
